// Style Constants
export const STYLES = {
  BUTTONS: {
    BASE: 'font-bold rounded-lg transition-all duration-200 flex items-center justify-center space-x-2 focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed',
    PRIMARY: 'bg-red-500 text-white hover:bg-red-600 focus:ring-red-500 shadow-lg hover:shadow-xl transform hover:scale-105',
    SECONDARY: 'bg-gray-500 text-white hover:bg-gray-600 focus:ring-gray-500',
    DANGER: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-600',
    SIZES: {
      SM: 'px-4 py-2 text-sm',
      MD: 'px-6 py-3 text-base',
      LG: 'px-8 py-4 text-lg',
    },
  },
  INPUTS: {
    BASE: 'w-full px-4 py-3 bg-white border border-red-500/30 rounded-lg shadow-sm focus:ring-2 focus:ring-red-500 focus:border-red-500 text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed',
    LABEL: 'block text-sm font-medium text-gray-700 mb-2',
    HELP_TEXT: 'text-gray-500 text-xs mt-1',
    ERROR: 'border-red-500 focus:ring-red-500',
  },
  CARDS: {
    DEFAULT: 'bg-white border border-gray-200',
    RED: 'bg-white/95 backdrop-blur-sm border border-red-500/30',
    TRANSPARENT: 'bg-white/90 backdrop-blur-sm border-2 border-dashed border-red-500/50',
    BASE: 'rounded-lg shadow-xl p-6',
  },
  COLORS: {
    RED: {
      BG: 'bg-red-100',
      BORDER: 'border-red-200',
      TEXT: 'text-red-800',
      PROGRESS: 'bg-red-500',
      ICON: 'text-red-600',
    },
    YELLOW: {
      BG: 'bg-yellow-100',
      BORDER: 'border-yellow-200',
      TEXT: 'text-yellow-800',
      PROGRESS: 'bg-yellow-500',
      ICON: 'text-yellow-600',
    },
    GREEN: {
      BG: 'bg-green-100',
      BORDER: 'border-green-200',
      TEXT: 'text-green-800',
      PROGRESS: 'bg-green-500',
      ICON: 'text-green-600',
    },
  },
  ANIMATIONS: {
    SPIN: 'animate-spin rounded-full border-2 border-gray-300 border-t-red-500',
    PULSE: 'animate-pulse',
    BOUNCE: 'animate-bounce',
  },
} as const;